<template>
	<div>
		<base-header class="pb-6 bg-light">
			<!-- Page header -->
			<b-row aling-v="center" class="py-4">
				<b-col cols="12" lg="6">
					<h6 class="h2 d-inline-block mb-0 text-dark">Discrepancy Check</h6>
				</b-col>
				<b-col cols="12" lg="6" class="text-right">
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</b-col>
			</b-row>
		</base-header>
		<b-card no-body>
			<b-card-header>
				<b-row class="justify-content-center">
					<b-col cols="auto">
						<label for="sim-type" class="font-weight-900 text-sm">Report Type</label>
					</b-col>
					<b-col cols="4">
						<b-input-group>
							<b-form-select
								id="sim-type"
								v-model="reportType"
								:options="reportTypeOptions"
								selected="All"
								value-field="reportType"
								text-field="value"
								size="sm"
								disabled-field="notEnabled"
								@change="setReportType($event)"
							>
							</b-form-select>
							<b-button
							variant="primary"
							size="sm"
							@click="getData"
							:disabled="loadingStatus"
							>
							Search</b-button>
						</b-input-group>
					</b-col>
				</b-row>
			</b-card-header>
			<b-card-body class="p-3">
				<b-container>
					<div class="text-center w-100"
							v-if="loadingStatus">
						<b-icon
							icon="three-dots"
							class="text-center"
							animation="cylon"
							font-scale="4"
						></b-icon>
					</div>
					<div class="primary-table" v-if="!loadingStatus">
						<b-row>
							<b-col cols="12" xl="8" lg="7" md="7" sm="6">
								<b-form-group
									label=""
									label-for="per-page-select"
									label-cols-sm="0"
									label-cols-md="0"
									label-cols-lg="0"
									label-align-sm="center"
									label-size="sm"
									class="mb-2 per-page-select"
								>
									<label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
									<b-form-select
										id="per-page-select"
										class="diameter-report-select"
										v-model="perPage"
										:options="pageOptions"
										size="sm"
										v-on:input="getTotalRows"
									></b-form-select>
								</b-form-group>
							</b-col>
							<b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
								<b-form-group
									label=""
									label-for="filter-input"
									label-align-sm="right"
									label-size="sm "
									class="mb-0 per-page-select"
								>
									<label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
									<b-input-group size="sm">
										<b-form-input
											id="filter-input2"
											v-model="filter"
											class="mb-4"
										></b-form-input>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-table
							:fields="fields"
							:items="items"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
							:sort-direction.sync="sortDirection"
							:sort-direction="sortDirection"
							class="text-center primary-table"
							hover
							responsive
							show-empty
							small
							striped
							@filtered="onFiltered"
						>
							<template #cell(product)="row">
								{{ row.value }}
							</template>
							<template #cell(status)="row">
								<b-badge
									class="p-1 text-white"
									:class="row.value.toLowerCase() === 'active' ? 'bg-success' : 'bg-danger'"
								>
									{{ row.value }}
								</b-badge>
							</template>
							<template #cell(imsi)="row">
								{{ row.value }}
							</template>
							<template #cell(subscriber)="row">
								{{ row.value }}
							</template>
							<template #cell(tn)="row">
								{{ row.value }}
							</template>
						</b-table>
					</div>
					<b-row class="mt-4" v-if="items.length > 0">
								<b-col> Showing {{ startPage() }} - {{ lastPage() }} of {{ totalRows }} entries </b-col>
								<b-col xl="auto" md="auto" sm="auto ">
									<b-pagination
										class="flex-fill-custom pr-4"
										v-model="currentPage"
										:total-rows="totalRows"
										:per-page="perPage"
										size="sm"
									></b-pagination>
								</b-col>
							</b-row>
				</b-container>
			</b-card-body>
		</b-card>
	</div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import troubleshootingService from "../../../common/api-services/troubleshooting-service";
import initService from "../../../common/api-services/init-service";
import pagination from "../../../common/format/pagination";
export default {
	name: "discrepancy-check",
	components: {
		RouteBreadCrumb,
	},
	mounted() {
		document.title = "Troubleshooting - Discrepancy Check";

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		}
	},
	data() {
		return {
			items: [],
			fields: [
				{key: "product", label: "Product", sortable: true, sortDirection: "desc"},
				{key: "status", label: "Status", sortable: true, sortDirection: "desc"},
				{key: "imsi", label: "IMSI", sortable: true, sortDirection: "desc"},
				{key: "subscriber", label: "Subscriber", sortable: true, sortDirection: "desc"},
				{key: "tn", label: "TN", sortable: true, sortDirection: "desc"},
			],
			reportType: "All",
			reportTypeOptions: [
				{reportType: "All", value: "All"},
				{reportType: "essential", value: "Essential"},
				{reportType: "difference", value: "Difference"},
				{reportType: "nonessential", value: "Non-Essential"},
			],
			results: {},
			type: "all",
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			loadingStatus: false,
			sortBy: "",
			sortDesc: false,
			sortDirection: "asc",
			filter: null,
			fromPage: 0,
			totalRows: 0,
		};
	},
	computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		}
	},
	methods: {
		async getData(event) {
			event.preventDefault();
			this.loadingStatus = true;
			this.items = [];
			this.results = {};
			this.totalRows = 0;
			this.currentPage = 1;
			this.fromPage = 0;
			troubleshootingService
				.getDiscrepancyCheck()
				.then(response => {
					let data = structuredClone(response.message);
					data.all = data.essential.concat(data.difference, data.nonessential);
					this.results = data;
					this.items = data[this.type];
					this.totalRows = this.items.length;
					this.fromPage = this.currentPage * this.perPage;
					this.loadingStatus = false;
				})
				.catch(error => {
					console.log(error);
				});
		},
		
		setReportType(value) {
			this.type = value.toLowerCase();
		},

		getTotalRows() {
			if (this.perPage > this.totalRows) {
				this.fromPage = this.totalRows;
			} else {
				this.fromPage = this.perPage;
			}
		},

		startPage() {
			return pagination.startPageFunc(this.currentPage, this.perPage);
		},

		lastPage() {
			return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
		},

		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
      	},
	},
};
</script>
